import React, { useEffect, useState } from 'react';
import { SwitherComponent } from 'component/Swither';

import { AccordionBodyItem } from 'component/Accordion';
import { ReportTypeChangeDialog } from 'component/Dialog';

export const ReportTypeInfo = (props) => {
  const [switherState, setSwitherState] = useState(false);

  const [dialogOpen, setDialogOpen] = useState(false);
  const [pendingSwitcherValue, setPendingSwitcherValue] = useState(null);

  useEffect(() => {
    if (props?.formData?.info?.general?.from_existing_ha_report === undefined) {
      props.setFormData((prevFormData) => ({
        ...prevFormData,
        info: {
          ...prevFormData.info,
          general: {
            ...prevFormData.info.general,
            from_existing_ha_report: false,
          },
        },
      }));
    }

    const isExistingReport = props?.formData?.info?.general?.from_existing_ha_report;
    setSwitherState(!isExistingReport);
  }, [props?.formData?.info?.general?.from_existing_ha_report]);

  const handleSwitcherChange = (newValue) => {
    if (props.mode === 'create') {
      setSwitherState(newValue);
      props.setFormData((prevFormData) => ({
        ...prevFormData,
        info: {
          ...prevFormData.info,
          general: {
            ...prevFormData.info.general,
            from_existing_ha_report: !newValue,
          },
        },
      }));

      if (props.onReportTypeChange) {
        props.onReportTypeChange(!newValue);
      }
    } else {
      setPendingSwitcherValue(newValue);
      setDialogOpen(true);
    }
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
    setPendingSwitcherValue(null);
  };

  const handleDialogConfirm = () => {
    setSwitherState(pendingSwitcherValue);

    props.setFormData((prevFormData) => ({
      ...prevFormData,
      info: {
        ...prevFormData.info,
        general: {
          ...prevFormData.info.general,
          from_existing_ha_report: !pendingSwitcherValue,
        },
      },
    }));

    if (props.onReportTypeChange) {
      props.onReportTypeChange(!pendingSwitcherValue);
    }

    setDialogOpen(false);
    setPendingSwitcherValue(null);
  };

  return (
    <>
    <AccordionBodyItem
      accordionSubId={(
        <div>
        </div>
      )}
      titleUA="Тип звіту"
      titleEN="Report type"
      children={(
        <div className="flex-column-group align-right">
          <SwitherComponent
            labelRight={(
              <>
                <div>Оновити існуючий</div>
                <div>Update existing</div>
              </>
            )}
            labelLeft={(
              <>
                <div>Новий</div>
                <div>New</div>
              </>
            )}
            checked={switherState}
            handleSwitcher={handleSwitcherChange}
          />
        </div>
      )}
    />
      {props.mode !== 'create' && (
        <ReportTypeChangeDialog
          open={dialogOpen}
          onClose={handleDialogClose}
          onConfirm={handleDialogConfirm}
        />
      )}
  </>
  );
};